module.exports = __webpack_public_path__ + "img/Pictor.daf4c3da.png";